var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam Alacak Tutarı',"data":_vm.numberConverter(_vm.reportCompanyData.totalCurrentDebit),"description":'Tüm Zamanlar',"loading":_vm.reportCompanyDataLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }